export const CHANNEL_KEY = 'LA_LEY_BROADCAST_KEY';

export const UseCaseKeys = {
  AI_ASSISTANT: 'AI_ASSISTANT',
  DRAFTING: 'DRAFTING',
  MEMO: 'MEMO'
};

export const AIAssistantKeys = {
  LEGAL_ASSISTANT: 'LEGAL_ASSISTANT',
  USER_DOCUMENTS_ASSISTANT: 'USER_DOCUMENTS_ASSISTANT'
};

export type UseCaseKeyType = (typeof UseCaseKeys)[keyof typeof UseCaseKeys];
export type AIAssistantKeyType =
  (typeof AIAssistantKeys)[keyof typeof AIAssistantKeys];
